export default (e, len) =>
  String(e).length > len ? String(e).substring(0, len) + "..." : e;
